import type { ReactNode } from "react";

import { Stack } from "@mui/material";
import { cn } from "utils/styling";

type ScenarioFieldRowProps = {
  alignControlEnd?: boolean;
  children: ReactNode;
  className?: string;
  controlClassName?: string;
  label: string;
  labelClassName?: string;
};

export const ScenarioFieldRow = ({
  alignControlEnd = false,
  children,
  className,
  controlClassName,
  label,
  labelClassName,
}: ScenarioFieldRowProps) => {
  return (
    <Stack className={cn("h-10 w-full justify-between gap-2", className)}>
      <span className={cn("truncate text-lds-foreground-primary font-ds-body-semibold-sm", labelClassName)}>
        {label}
      </span>
      <div className={cn(alignControlEnd ? "w-[20rem]" : "flex-1", controlClassName)}>{children}</div>
    </Stack>
  );
};
